module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QwECjADEIb6TgAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAA3klEQVRYw2NgGAVDDSQsYPifsIDhP7XMYyHFYlp4iImSkKCGAxgptWhBAmEzaBIC1AoJnA6Ysj9EiVjD0dX9//9fBps4tgSM0wFnHq65S25IMDIyPiHW8UzUClbktICsP2EBw/+Hb88FEO0AciyfH/9fG5/++s1G64lyALkJipGR8RopUfTsw3U5DAeQazmuoCcpFwyU5VQpB6hSF6CXZth8A1ODTY5U30sJaD4aXCFAzSIXW0jhC70BDwEmUlI8pTUfRVFASVThi77hlwgHTUFEbJoZOrlg2DpgFIwCAODYYyR79l3QAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/activas_bi_con.png
// module id = TKTl
// module chunks = 0